var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2309 14.4867C1.59367 14.4867 0.866657 13.1464 1.68318 11.7037L6.4567 2.93512C7.28602 1.50745 8.73527 1.48246 9.54863 2.94288L14.3158 11.7015C15.1326 13.1493 14.4082 14.4867 12.7692 14.4867H3.2309ZM7.52007 5.50002V10.2084C7.52007 10.4735 7.73497 10.6884 8.00007 10.6884C8.26516 10.6884 8.48007 10.4735 8.48007 10.2084V5.50002C8.48007 5.23492 8.26516 5.02002 8.00007 5.02002C7.73497 5.02002 7.52007 5.23492 7.52007 5.50002ZM8.5634 12.1534C8.5634 12.4645 8.31119 12.7167 8.00007 12.7167C7.68895 12.7167 7.43673 12.4645 7.43673 12.1534C7.43673 11.8422 7.68895 11.59 8.00007 11.59C8.31119 11.59 8.5634 11.8422 8.5634 12.1534Z",
    fill: "#08081B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1683_9805",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2309 14.4867C1.59367 14.4867 0.866657 13.1464 1.68318 11.7037L6.4567 2.93512C7.28602 1.50745 8.73527 1.48246 9.54863 2.94288L14.3158 11.7015C15.1326 13.1493 14.4082 14.4867 12.7692 14.4867H3.2309ZM7.52007 5.50002V10.2084C7.52007 10.4735 7.73497 10.6884 8.00007 10.6884C8.26516 10.6884 8.48007 10.4735 8.48007 10.2084V5.50002C8.48007 5.23492 8.26516 5.02002 8.00007 5.02002C7.73497 5.02002 7.52007 5.23492 7.52007 5.50002ZM8.5634 12.1534C8.5634 12.4645 8.31119 12.7167 8.00007 12.7167C7.68895 12.7167 7.43673 12.4645 7.43673 12.1534C7.43673 11.8422 7.68895 11.59 8.00007 11.59C8.31119 11.59 8.5634 11.8422 8.5634 12.1534Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1683_9805)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#BD0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3d29da4ee55bff50cdee6db983acac56.svg";
export { ForwardRef as ReactComponent };